import { defineMessages } from '@jutro/locale';

export default defineMessages({
    renewalDateColumn: {
        id: 'ml.gateway.views.ActivityReports.MLMigrationsReport.RENEWAL DATE',
        defaultMessage: 'RENEWAL DATE'
    },
    newPolicyTypeColumn: {
        id: 'ml.gateway.views.ActivityReports.MLMigrationsReport.NEW POLICY TYPE',
        defaultMessage: 'NEW POLICY TYPE'
    },
    customerNameColumn: {
        id: 'ml.gateway.views.ActivityReports.MLMigrationsReport.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    newPolicyColumn: {
        id: 'ml.gateway.views.ActivityReports.MLMigrationsReport.NEW POLICY #',
        defaultMessage: 'NEW POLICY #'
    },
    newPremiumColumn: {
        id: 'ml.gateway.views.ActivityReports.MLMigrationsReport.NEW PREMIUM',
        defaultMessage: 'NEW PREMIUM'
    },
    noPolicyMigrationsFound: {
        id: 'ml.gateway.views.ActivityReports.MLMigrationsReport.No policy migrations found',
        defaultMessage: 'No policy migrations found'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLMigrationsReport.Loading...',
        defaultMessage: 'Loading...'
    },
    viewAllMigrations: {
        id: 'ml.gateway.views.ActivityReports.MLMigrationsReport.VIEW ALL MIGRATIONS',
        defaultMessage: 'VIEW ALL MIGRATIONS'
    }
});
